import { createFileRoute } from "@tanstack/react-router";
import { PerfilPage } from "@/features/perfil/components/PerfilPage";
import {
  miPerfilQueryOptions,
  misAsignacionesQueryOptions,
} from "@/features/perfil/hooks/use-perfil-queries";
import { seguridad2FAQueryOptions } from "@/features/seguridad/hooks/use-seguridad-queries";

/**
 * Ruta `/perfil` (P40) · Mi perfil · disponible para TODOS los roles
 * autenticados (cada quien configura su propia cuenta).
 *
 * El loader PRECARGA perfil + asignaciones + estado del 2FA para que los
 * datos ya estén (o estén viajando) cuando la página monta · evita el
 * fetch-on-render que dejaba las secciones "en blanco" hasta que respondía
 * el servidor. Se espera solo el perfil (la cabecera de la página); los
 * otros dos se prefetch sin bloquear la navegación.
 */
export const Route = createFileRoute("/_authed-tw/perfil")({
  loader: ({ context: { queryClient } }) => {
    void queryClient.prefetchQuery(misAsignacionesQueryOptions);
    void queryClient.prefetchQuery(seguridad2FAQueryOptions);
    return queryClient.ensureQueryData(miPerfilQueryOptions);
  },
  component: PerfilPage,
});
